import { Platform } from 'react-native'

export type FilesRowProps = {
  isFull: boolean
  isLastRow: boolean
  rowFilesLength: number
  shouldRenderInlineUpload: boolean
}

export const getRowJustifyContent = ({
  isFull,
  isLastRow,
  rowFilesLength,
  shouldRenderInlineUpload,
}: FilesRowProps): 'space-between' | 'flex-start' => {
  if (Platform.OS === 'web') {
    return isFull ? 'space-between' : 'flex-start'
  }
  if (rowFilesLength <= 2 && (rowFilesLength > 1 || shouldRenderInlineUpload)) {
    return 'space-between'
  }
  if (isLastRow && rowFilesLength > 2) {
    return 'space-between'
  }
  return 'flex-start'
}

export const getItemMarginRight = (
  marginRight: number,
  isLastItemInRow: boolean,
  isFull: boolean,
  isLastRow: boolean,
  rowFilesLength: number,
  shouldRenderInlineUpload: boolean
): number => {
  if (Platform.OS === 'web') {
    return isFull && isLastItemInRow ? 0 : marginRight
  }
  if (rowFilesLength <= 2 && (rowFilesLength > 1 || shouldRenderInlineUpload)) {
    return isLastItemInRow || (shouldRenderInlineUpload && rowFilesLength <= 2) ? 0 : marginRight
  }
  if (isLastRow && rowFilesLength > 2) {
    return isLastItemInRow ? 0 : marginRight
  }
  return marginRight
}
